import { getAnalytics, logEvent } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import * as fbAuth from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.FIREBASE_API_KEY,
  appId: import.meta.env.FIREBASE_APP_ID,
  authDomain: import.meta.env.FIREBASE_AUTH_DOMAIN,
  measurementId: import.meta.env.FIREBASE_MEASUREMENT_ID,
  messagingSenderId: import.meta.env.FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.FIREBASE_STORAGE_BUCKET,
}

// Initialize Firebase
export const azureAD = new fbAuth.OAuthProvider('microsoft.com')

export const firebase = initializeApp(firebaseConfig)
export const firebaseAuth = fbAuth.getAuth(firebase)

const analytics = getAnalytics(firebase)

export const event = (
  eventName: string,
  params?: {
    [key: string]: unknown
  },
) => {
  return logEvent(analytics, eventName, params)
}

export const signInWithPopup = (
  resolver?: Parameters<typeof fbAuth.signInWithPopup>,
) => {
  fbAuth.setPersistence(firebaseAuth, fbAuth.browserSessionPersistence)
  return fbAuth.signInWithPopup(firebaseAuth, azureAD, resolver)
}
